"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var PaymentDisclaimerModal_1 = require("../paymentDisclaimerModal/PaymentDisclaimerModal");
var paymentDisclaimerStyles_1 = require("./paymentDisclaimerStyles");
var react_intl_1 = require("react-intl");
var PaymentSummary_1 = require("../paymentSummary/PaymentSummary");
var ContinueButton_1 = require("../../buttons/continueButton/ContinueButton");
var PaymentTermsAndConditionsModal_1 = require("../paymentTermsAndConditions/PaymentTermsAndConditionsModal");
var usePlatformConfig_1 = require("../../../../../common/react/usePlatformConfig");
var PaymentDisclaimer = function (_a) {
    var handleClick = _a.handleClick;
    var _b = react_1.useState(false), isModalOpen = _b[0], setIsModalOpen = _b[1];
    var _c = react_1.useState(false), checked = _c[0], setChecked = _c[1];
    var styles = paymentDisclaimerStyles_1.default();
    var intl = react_intl_1.useIntl();
    var _d = usePlatformConfig_1.default().platformConfig.platformFeatures, usePaymentTermsAndConditionsModal = _d.usePaymentTermsAndConditionsModal, isPaymentModalDisabled = _d.isPaymentModalDisabled, useSubaruLink = _d.useSubaruLink;
    var openModal = react_1.useCallback(function (e) {
        if (!isPaymentModalDisabled) {
            e.preventDefault();
            var element = e.target;
            if (element && element.tagName === 'A') {
                setIsModalOpen(true);
            }
        }
    }, [isPaymentModalDisabled]);
    return (<core_1.Box className={styles.container} data-test="checkout:payment_disclaimer">
      <PaymentSummary_1.default />
      <core_1.FormControl fullWidth>
        <core_1.FormControlLabel className={styles.controlContainer} control={<core_1.Box className={styles.controlCheckbox}>
              <core_1.Checkbox className={styles.icon} color="primary" checked={checked} onChange={function (e) { return setChecked(e.target.checked); }} data-test="online_order:payment_disclaimer:checkbox"/>
            </core_1.Box>} label={<core_1.Typography data-test="online_order:payment_disclaimer:label" onClick={!useSubaruLink ? openModal : undefined} className={styles.paymentDisclaimerLabel} dangerouslySetInnerHTML={{
        __html: intl.formatMessage({
            id: 'trans__checkout__next_step__payment_page_disclaimer',
        }),
    }}/>}/>
      </core_1.FormControl>
      <core_1.Box className={styles.buttonWrapper}>
        <ContinueButton_1.default testId="checkout:continue_button:payment_disclaimer" activateNextStep={false} disabled={!checked} handleClick={handleClick} className={styles.continueButton}/>
      </core_1.Box>
      {!isPaymentModalDisabled && usePaymentTermsAndConditionsModal ? (<PaymentTermsAndConditionsModal_1.default isOpen={isModalOpen} setIsOpen={setIsModalOpen} setIsAccepted={setChecked}/>) : (<PaymentDisclaimerModal_1.default isOpen={isModalOpen} toggleModal={setIsModalOpen}/>)}
    </core_1.Box>);
};
exports.default = PaymentDisclaimer;
